import { CHATBOT_COMMANDS } from '~/utils/chat-flags';
import { patchPhoneCreditPrepaidTransactionStatus } from '~/api/phone-credit-prepaid';
import { getInvoices } from '~/api/invoices';

export default {
  methods: {
    /**
     * Unstuck data-plan-prepaid transaction, making sure get the latest data from the partner dashboard
     * @command - [apicall] unstuckDataPlanPrepaidTrx [/apicall]
     * @param {object} currentTrx - currently selected transaction object
     */
    async unstuckDataPlanPrepaidTrx(currentTrx) {
      if (!currentTrx) {
        this.$zopim.sendChatMsg(CHATBOT_COMMANDS.responses.noSelectedTransaction);
        return;
      }

      const responses = {
        unstuckDataPlanPrepaidTrxIsDone: '[apiresponse] unstuckDataPlanPrepaidTrxIsDone [/apiresponse]',
      };

      try {
        // Get invoice data
        const {
          data: [invoiceData],
        } = await getInvoices(this.$axios, { keywords: currentTrx.paymentId });
        const {
          transactions: [invoiceTrx],
        } = invoiceData;

        await patchPhoneCreditPrepaidTransactionStatus(this.$axios, {
          transactionId: invoiceTrx.id,
          action: 'unstuck',
        });
        this.$zopim.sendChatMsg(responses.unstuckDataPlanPrepaidTrxIsDone);
      } catch (error) {
        this.$zopim.sendChatMsg(responses.unstuckDataPlanPrepaidTrxIsDone);
        console.error('[ERROR] Something is wrong when trying to unstuck data-plan-prepaid transaction', error);
      }
    },
  },
};
